// 计算账期

const calAccountPeriod = (date, nextN = 0) => {
  //  计算当前账期 （2月25号 - 3月24号 为3月账期, 输出 2021-03）
  const today = date.getDate()
  let thisMonth = date.getMonth() + 1 + nextN // 可计算下n个账期
  let thisYear = date.getFullYear()

  let accountPeriod = ''

  // 25号及以后为下个账期
  if (today >= 25) {
    // 如当前为12月，则调整为下一年一月
    if (thisMonth === 12) {
      thisYear++
      thisMonth = 1
    } else {
      thisMonth++
    }
  }

  accountPeriod = thisYear + '-' + thisMonth.toString().padStart(2, '0')

  return accountPeriod
}

const getCurMonthStr = () => {
  return new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0')
}
export default calAccountPeriod
export {
  calAccountPeriod,
  getCurMonthStr
}
